export default __webpack_public_path__ + "static/media/Cielo.4506a362.jpg";